import { FormEvent, useContext, useState } from "react"
import { toast } from "react-toastify"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import { iniciarSessaoWa } from "../../services/wa"
import { Button, Loader } from "../Styles"
import integracaoImg from '../../assets/img/integracao.png'
import { descriptografarDado } from "../../helpers"

function ModalIntegracaoWhatsapp() {
    const { atualizarDados } = useContext(ModalEstadoContext)

    const { modalExibir } = useContext(ModalEstadoContext)

    const [idWa, setIdWa] = useState("");
    const [idWaba, setIdWaba] = useState("");
    const [token, setToken] = useState("");
    const [processando, setProcessando] = useState(false)

    const cadastrarIntegracaoWhatsApp = async (e: FormEvent) => {
        e.preventDefault()

        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'configuracao_integracao']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para fazer uma integração com o WhatsApp.")
        setProcessando(true)

        try {

            const payload = {
                idWa,
                idWaba,
                token
            }

            const resposta = await iniciarSessaoWa(payload)

            if (resposta.status === 200) {
                setProcessando(true)
                toast.success("Integração realizada com Sucesso.")
                toast.success("Sincronize os modelos para começar a usar a integração.")
                atualizarDados()
                modalExibir("")
            }

        } catch (error: any) {
            if (error.status === 401) {
                return toast.error("Credenciais inválidas ou expiradas.")
            }
            if (error.status === 400) {
                return toast.error("IdWaba ou IdWa informado não é válido. Tente Novamente")
            }
            if (error.response.status === 404) {
                return toast.warn('Configuração do WhatsApp não encontrada.')
            }

            return toast.error('Ocorreu um Erro ao Realizar Integração com o WhatsApp.')
            
        } finally {
            setProcessando(false)
        }
    }

    return (
        <div id='fundoModal' className='fundoModalIntegracaoInter'>
            <section className='containerModalCentro'>
                <span id='novoContainerTitulo'>
                    <img id='adicionarModalIcone' src={integracaoImg} alt='' />
                    <p>Conectar Whatsapp</p>
                </span>
                <div id='formModalNovo'>
                    <form onSubmit={cadastrarIntegracaoWhatsApp}>
                        <section>
                            <span>
                                <label htmlFor="">IdWaba</label>
                                <input
                                    type="text"
                                    value={idWaba}
                                    maxLength={100}
                                    onChange={(e) => setIdWaba(e.target.value)}
                                    placeholder="Número da conta de whatsapp"
                                    required
                                />
                            </span>
                        </section>
                        <section>
                            <span>
                                <label htmlFor="">IdWa</label>
                                <input
                                    type="text"
                                    value={idWa}
                                    maxLength={100}
                                    onChange={(e) => setIdWa(e.target.value)}
                                    placeholder="Identificador do número de telefone"
                                    required
                                />
                            </span>
                        </section>
                        <section>
                            <span>
                                <label htmlFor="">Token</label>
                                <textarea
                                    value={token}
                                    rows={6}
                                    maxLength={500}
                                    onChange={(e) => setToken(e.target.value)}
                                    placeholder="Preencha com o token gerado pelo usuário de sistema"
                                    required
                                />
                            </span>
                        </section>

                        <p className="infoIntegracaoWhatsApp">
                            <i>O uso da API oficial do WhatsApp pode gerar cobranças adicionais feitas diretamente pela Meta. É necessário que a conta do WhatsApp possua uma forma de pagamento válida.</i>
                        </p>
                        <span id="botoesContainer">
                            <Button type='button' cor='cancelar' isLoading={processando} onClick={() => modalExibir('')}>Cancelar</Button>
                            <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                                {!processando && 'Salvar Dados'}
                                {processando && <Loader isLoading={processando} />}
                            </Button>
                        </span>
                    </form>
                </div>
            </section>
        </div>
    )
}

export default ModalIntegracaoWhatsapp